/*
 Dependencies
 */

import {Module} from "wrapper6";
import {debounce} from "./../_utils";

var $ = jQuery;

export default class NewsBar extends Module {

    boot() {
        if ($('.mtt-news-bar').length === 0) {
            return false;
        }
    }

    ready(app) {
        this.newsBarAnimation();
    }

    newsBarAnimation() {
        const BAR = document.querySelector('.mtt-news-bar__animation-wrapper');
        if (BAR) {
            setTimeout(() => {
                BAR.classList.add('mtt-news-bar__animation-wrapper--animate');
            }, 500);
        }
    }  
}